import { WithProps } from '@/types/core-types'
import { FieldHookConfig, useField } from 'formik'
import React, { ChangeEvent } from 'react'

type ExpirationDateFieldProps = { label?: string; showError?: boolean; placeholder?: string } & FieldHookConfig<any>

const ExpirationDateField: React.FC<ExpirationDateFieldProps> = ({
  className,
  label,
  required,
  placeholder,
  showError = true,
  ...props
}) => {
  const [field, meta, helpers] = useField(props)
  const { error } = meta
  const hasError = meta.touched && meta.error ? true : false

  const handleInputChange = (e: ChangeEvent<any>) => {
    const { value } = e.target
    let formattedValue = value
      .replace(
        /[^0-9]/g,
        '', // Remove non-digit characters
      )
      .substring(0, 4) // Max length: MMYY

    if (formattedValue.length >= 3) {
      formattedValue = formattedValue.substring(0, 2) + '/' + formattedValue.substring(2, 4)
    }

    helpers.setValue(formattedValue)
  }

  return (
    <div className={className}>
      <label htmlFor={field.name} className={`block text-sm font-medium  text-gray-700`}>
        {label}
        {required && <span className="ml-1 text-red-500">*</span>}
      </label>
      <div className="mt-1">
        <input
          {...field}
          onChange={handleInputChange}
          placeholder={placeholder}
          className={`block w-full rounded-md border-gray-300 shadow-sm placeholder:text-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm ${
            hasError ? 'border-red-500' : ''
          }`}
        />
        {showError && hasError && <p className="mt-2 text-sm text-red-500">{error}</p>}
      </div>
    </div>
  )
}
export default ExpirationDateField
